// * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
// *
// * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
// * and other pending or existing intellectual property rights in India, the United States and other countries. The Program
// * may contain / reference third party or open source components, the rights to which continue to remain with the applicable
// * third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
// * and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
// * form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
// * otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
// * prosecuted to the maximum extent possible under the law.
import { Component, OnInit, Input, Output, OnChanges, SimpleChange, ViewChild, AfterViewChecked, AfterViewInit, EventEmitter } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss'],
    standalone: false
})

export class ExpansionPanelComponent implements OnInit, AfterViewInit {
	@Input() isPanelOpened: Boolean;
	@Input() title: String;
	@Input() description: String;
	@Input() content:Array<Object>;

	@Input() showContentAsTable: Boolean;
	@Input() contentTableHasLinks: Boolean;
	@Input() contentTableLinks: Array<Object>;
	@Input() displayedFields: Array<String>;
	@Input() tableSearchValue:String;

	@Input() initialPageIndex: number;
	@Input() contentTablePageSizeOptions: Array<number>;
	@Input() contentTablePageSize: number;
	@Input() nextDataSet: Array<Object>;
	@Input() totalNumberOfRecords: number;
	isDisabled: Boolean;
	showActionBar: Boolean = false;
	dataSource;
	dataSourceSize;
	@Output() matPaginatorPageEvent = new EventEmitter<PageEvent>();
	@ViewChild(MatPaginator) paginator: MatPaginator;

  	constructor() {
  		this.showContentAsTable = false;
  	}
	ngOnInit() {
		//console.log(this)
		if(typeof this.isPanelOpened === 'undefined'){
			this.isPanelOpened = false;
		}
		if(!this.showContentAsTable){
			this.contentTableHasLinks = undefined;
			this.contentTableLinks = undefined;
			this.contentTablePageSizeOptions = undefined;
			this.contentTablePageSize = undefined;
			this.initialPageIndex = undefined;
			this.nextDataSet = undefined;
		}
	}
	generateLinks(linkForColumn,linkValue){
		if(!this.contentTableHasLinks){
			return;
		}
		let linkSrc = '';
		for(let index in this.contentTableLinks){
			let contentLinkData = this.contentTableLinks[index];
			if(contentLinkData['matColumnDef'] && contentLinkData['matColumnDef'].toString().length > 0 
				&& contentLinkData['matColumnDef'].toString().trim() == linkForColumn){
				linkSrc = contentLinkData['link'].replace('PRICE_REQUEST_ID',linkValue);
			break;
			}
		}
		return linkSrc;
	}
	ngAfterViewInit() {
		let self = this;
		self.dataSource = new MatTableDataSource();
		self.dataSource.data = self.content;
		//self.dataSourceSize = self.dataSource.data.length;
		this.dataSourceSize = 100;
		self.dataSource.paginator = null;
	}
	ngAfterViewChecked(){
		if(this.dataSource.paginator == null){
			this.dataSource.paginator = this.paginator;
		}
	}
	ngOnChanges(changes: {[propKey: string]: SimpleChange}){
		//console.log(changes);
		let self = this;
		let lookFor = changes['tableSearchValue'];
		let contentChanges = changes['content'];
		if(contentChanges && contentChanges.currentValue instanceof Array && contentChanges.currentValue.length == 0){
			self.isDisabled = true;
		}
		if(lookFor && typeof lookFor.currentValue !== 'undefined'){
			this.applyFilter(changes['tableSearchValue'].currentValue);
		}
		if(changes['nextDataSet'] && changes['nextDataSet']['currentValue'] instanceof Array &&  changes['nextDataSet']['currentValue'].length > 0){
			let newDataSourceToAppend = changes['nextDataSet']['currentValue'].find((elem)=>elem.title==self.title);	
			if(newDataSourceToAppend.content && newDataSourceToAppend.content instanceof Array && newDataSourceToAppend.content.length > 0){
				self.dataSource.data = self.dataSource.data.concat(newDataSourceToAppend.content);
				//self.dataSourceSize = self.dataSource.data.length;
			}			
		}
	}
	applyFilter(filterValue: string) {
		filterValue = filterValue.trim(); // Remove whitespace
		filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
		this.dataSource.filter = filterValue;
	}
	paginationEvent(event){
		this.matPaginatorPageEvent.emit(event);
	}
}

